export const LOCATION_CHANGE_EVENT = 'location_change'

const INITIALIZED_FLAG = '__dynamicLocationChangeInitialized'

export function initializeLocationChangeEvents() {
  if (window[INITIALIZED_FLAG]) return

  window.addEventListener('popstate', () => dispatchLocationChange('pop'))
  window[INITIALIZED_FLAG] = true
}

export function push(state, title, url) {
  window.history.pushState(state, title, url)
  dispatchLocationChange('push')
}

export function replace(state, title, url) {
  window.history.replaceState(state, title, url)
  dispatchLocationChange('replace')
}

export function pop() {
  window.history.back()
}

function dispatchLocationChange(source) {
  document.dispatchEvent(
    new CustomEvent(LOCATION_CHANGE_EVENT, {
      detail: {
        source,
        url: window.location.href,
      },
    })
  )
}

initializeLocationChangeEvents()
